angular.module('clients')
    .component('clientTypeIcon', {
        bindings: {
            type: '<',
        },
        template: `
            <i ng-if="$ctrl.type" class="fa customer-type-{{$ctrl.type}}" ng-class="{ 'fa-user' : $ctrl.type === 'RETAIL', 'fa-industry': $ctrl.type === 'COMPANY' }" uib-tooltip="{{ 'client.type.'.concat($ctrl.type) | translate }}" tooltip-placement="bottom"></i>
        `
    })
